import { faInbox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, styled } from "@mui/material";
import { DataGrid, GridOverlay, ptBR } from "@mui/x-data-grid";
import Footer from "../Footer/Footer";
import { useState, useEffect } from "react";

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    '&.MuiDataGrid-root': {
        border: 'none',
        padding: "10px 2px",
        backgroundColor: "#494949",
    },
    '&.MuiDataGrid-menuIcon MuiDataGrid-menuOpen': {
        color: "#fff"
    },
    '& .MuiDataGrid-iconSeparator': {
        display: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: "#494949",
        color: "#fff",
        fontWeight: "200"
    },
    '& .MuiDataGrid-sortIcon': {
        color: "white",
        bold: true
    },
    '& .MuiDataGrid-menuIconButton': {
        color: "white"
    },
    '& .MuiDataGrid-row': {
        backgroundColor: "#494949",
        borderRadius: "10px",
        minHeight: "40px !important",
        maxHeight: "40px !important",
        color: "#fff",
        fontSize: "14px",
        '&.Mui-selected': {
            background: 'transparent linear-gradient(79deg, #6D79EC 0%, #8166F5 100%) 0% 0% no-repeat padding-box;',
        }

    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
        backgroundColor: '#595959',
    },
    '&>.MuiDataGrid-main': {
        '&>.MuiDataGrid-columnHeaders': {
            borderBottom: 'none',
        },

        '& div div div div >.MuiDataGrid-cell': {
            borderBottom: 'none',
        },
    },
    '& .MuiDataGrid-footerContainer': {
        color: "#fff"
    },
    '&.MuiTablePagination-actions': {
        color: "#fff"
    },
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
        outline: "none"
    }
}))

function CustomNoRowsOverlay() {
    return (
        <GridOverlay>
            <FontAwesomeIcon icon={faInbox} />
            <Box sx={{ mt: 1 }}>Nenhum registro encontrado</Box>
        </GridOverlay>
    );
}

const Lista = ({ rows, columns, setSelectedData, onDblClick, hideFooter, autoHeight, pageSize = 100 }) => {
    const [selectionModel, setSelectionModel] = useState([]);

    useEffect(() => {
        setSelectionModel([]);
    }, [rows]);

    const handleEditItem = (params) => {
        setSelectedData(params.row);
        setSelectionModel([params.id]);
        onDblClick(true);
    }

    const handleRowClick = (params) => {
        setSelectedData(params.row);
        setSelectionModel([params.id]);
    }

    return (
        <StripedDataGrid
            rows={rows}
            columns={columns}
            onRowDoubleClick={handleEditItem}
            onRowClick={handleRowClick}
            localeText={{ ...ptBR.components.MuiDataGrid.defaultProps.localeText }}
            components={{
                NoRowsOverlay: CustomNoRowsOverlay,
                Footer: Footer
            }}
            hideFooter={hideFooter}
            rowsPerPageOptions={[5]}
            autoHeight={autoHeight}
            pageSize={pageSize}
            selectionModel={selectionModel}
            onSelectionModelChange={(newSelection) => {
                setSelectionModel(newSelection);
            }}
        />
    )
}

export { Lista };